/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Box } from "@mui/material";
import { StyledListItem } from "../../pages/reports/global_employee_search/styles";
import { LoadingSpinner } from "../loading_spinner";

export const CertificateList = ( { data = [], imageLoading, onCertificateClick } ) => {
  if(data?.length === 0) return ''
  
  return (
    <Box>
      <ul style={{padding: 0}} >
        {
          data?.map((item) => (
            <StyledListItem
              key={item?.id}
              onClick={() => onCertificateClick(item?.id)}
              style={{pointerEvents: imageLoading?.status && 'none'}}
            >
              { imageLoading?.status === true && imageLoading?.id === item?.id 
              ? 
                <div style={{width: '93px'}}>
                  <LoadingSpinner isLoading={true} />
                </div> 
              :  
                item ? item?.certificate_name : '-'}
            </StyledListItem>
          ))
        }
      </ul>
    </Box>
  )
}
